export default __webpack_public_path__ + "static/media/Time_Circle.bed69cec.svg";